import { all, put, takeLatest } from "redux-saga/effects";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import ReportScreenService from "../../services/ReportScreenService";
import {
  componentKey,
  getPatientReportsState,
  getVisitReportData,
  setAllGetPatientReportData,
  setAllGetReportData,
  setPatientReportMeta,
} from "./ReportScreenSlice";
import store from "../../store/store";

export const { patientReports, visitReport } = {
  patientReports: (payload) => {
    return {
      type: "REPORT/GET_PATIENT_LIST",
      payload,
    };
  },
  visitReport: (payload) => {
    return {
      type: "REPORT/GET_VISIT_LIST",
      payload,
    };
  },
};
function* getpatientListAsync(action) {
  try {
    const { limit } = action?.payload;
    yield put(showLoader());
    const response = yield ReportScreenService.getPatientListForReports(
      action?.payload
    );

    const { status, data } = response;
    if (status) {
      if (limit === "All") {
        yield put(setAllGetPatientReportData(data));
      }
      const { patient } = data;
      yield put(getPatientReportsState(patient));
      // Keep the pager's page count/total in sync — these live on `data`, not
      // on the `patient` array stored above.
      yield put(
        setPatientReportMeta({
          totalPages: data?.totalPages ?? 1,
          total: data?.total ?? 0,
        }),
      );
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}
function* getvisitListAsync(action) {
  try {
    const { limit } = action?.payload;
    yield put(showLoader());
    const response = yield ReportScreenService.getVisitListForReport(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data } = response;
      if (limit === "All") {
        yield put(setAllGetReportData(data));
      } else {
        yield put(getVisitReportData(data));
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}
function* rootSaga() {
  yield all([takeLatest(patientReports().type, getpatientListAsync)]);
  yield all([takeLatest(visitReport().type, getvisitListAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
